import { sound } from "@pixi/sound";
import { soundList } from "../types/Config";
import { Sounds } from "../types/Enum";
export default class SoundManager {
  static sound = {};
  static soundName = Sounds;
  static isMuted = false;
  constructor() {
  }

  static async load() {
    soundList.forEach(({ name, url }) => {
      sound.add(name, url);
      this.sound[name] = sound.find(name);
    })
  }

  static play = (name: Sounds, loop = false, volume = 1) => !this.isMuted && this.sound[name].play({ loop, volume });
  static stop = (name: Sounds) => this.sound[name].stop();
  static playBgSound = () => this.play(this.soundName.background, true, .1);

  static muteAll = () => {
    this.isMuted = true;
    this.stop(this.soundName.background);
  }

  static unmuteAll() {
    this.isMuted = false;
    this.playBgSound();
  }
}